import React, { useEffect, useState } from "react";
import Header from "../../../components/common/header";
import Sidenav from "../../../components/common/sidenav";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchTeamMembers } from "../../../store/slices/teamSlice";
import { fetchBusiness } from "../../../store/slices/businessSlice";
import { fetchCardList } from "../../../store/slices/paymentSlice";
import { fetchUsers } from "../../../store/slices/userSlice";
import { fetchAppointments } from "../../../store/slices/appointmentSlice";
import {
  fetchReviewList,
  fetchTotalReviews,
} from "../../../store/slices/reviewSlice";
import { generateToken, stripVerification } from "../../../api/auth";
import { fetchService } from "../../../store/slices/serviceSlice";
import { updateBusiness } from "../../../api/payment";

const { Content } = Layout;

const Mainpage = () => {
  const [verify, setVerify] = useState(true);
  const dispatch = useDispatch();
  const businessId = localStorage.getItem("businessId");
  const fetchData = async () => {
    dispatch(fetchUsers());
    dispatch(fetchTeamMembers());
    dispatch(fetchBusiness());
    dispatch(fetchCardList());
    dispatch(fetchAppointments(1));
    dispatch(fetchReviewList({ businessId }));
    const payload = {
      pageNumber: 1,
      pageSize: 10,
    };
    dispatch(fetchTotalReviews(businessId));
    dispatch(fetchService(payload));
  };

  const stripeVerification = async () => {
    const res = await stripVerification();
    if (!res?.account?.charges_enabled) {
      setVerify(false);
    }
    if (
      res?.account?.charges_enabled &&
      !res?.businessData?.isConnectAccountActive
    ) {
      const businessUpdate = updateBusiness({ isConnectAccountActive: true });
    }
  };

  const tokenn = async () => {
    const regToken = await generateToken();
    window.open(regToken?.url, "_self");
  };
  useEffect(() => {
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    stripeVerification();
  }, []);

  return (
    <Layout className="h-screen">
      <Sidenav />
      <Layout style={{ minHeight: "100vh" }}>
        <Header breakpoint="lg" collapsedWidth="0" className="position-fixed" />
        <div>
          {!verify && (
            <div
              className="flex justify-center  "
              style={{ backgroundColor: "rgb(239 68 68)" }}
            >
              <p className="text-white ">
                ⚠️ Your stripe account is not completed.{"  "}
                <u
                  onClick={tokenn}
                  className="hover:cursor-pointer font-medium text-lg"
                >
                  Complete it now
                </u>
              </p>
            </div>
          )}
        </div>
        <Content className="w-full overflow-auto bg-white over">
          <div className=" bg-white">
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Mainpage;
